import { render, staticRenderFns } from "./SelfiePreview.vue?vue&type=template&id=587ede26&scoped=true&"
import script from "./SelfiePreview.vue?vue&type=script&lang=js&"
export * from "./SelfiePreview.vue?vue&type=script&lang=js&"
import style0 from "./SelfiePreview.vue?vue&type=style&index=0&id=587ede26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587ede26",
  null
  
)

export default component.exports